// Timezone-aware date formatting utilities.
// All locale-sensitive output uses 'en-GB' (DD Mon YYYY order).

// Format a Date in a given timezone with arbitrary Intl options.
export function formatInTimezone(date, timezone, options) {
  return new Intl.DateTimeFormat('en-GB', { timeZone: timezone, ...options }).format(date);
}

// Extract calendar/time parts as numbers in a given timezone.
// Returns { year, month (1-12), day, hour (0-23), minute }.
// Handles the midnight quirk where hour12:false can return 24 instead of 0.
export function getPartsInTimezone(date, timezone) {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const v = Object.fromEntries(
    parts.filter((p) => p.type !== 'literal').map((p) => [p.type, +p.value]),
  );
  return { ...v, hour: v.hour % 24 };
}

// Pre-shift a UTC timestamp (ms) so that ApexCharts renders the correct local
// wall-clock time when datetimeUTC: true is set.
// e.g. midnight UTC in EAT (UTC+3) → returns 03:00 UTC, so ApexCharts shows "03:00".
export function shiftToTimezone(tsMs, timezone) {
  const { year, month, day, hour, minute } = getPartsInTimezone(new Date(tsMs), timezone);
  return Date.UTC(year, month - 1, day, hour, minute);
}

// Returns the UTC timestamp (ms) for midnight of a calendar date in the given timezone.
// e.g. midnight on 2025-01-06 in EAT (UTC+3) → 2025-01-05T21:00:00Z
export function localMidnightToUTC(year, month, day, timezone) {
  const estimate = Date.UTC(year, month - 1, day);
  const { hour, minute } = getPartsInTimezone(new Date(estimate), timezone);
  return estimate - (hour * 60 + minute) * 60000;
}
